import "~/misc/common";
import DeviceBase from "./device_base";
export default class extends DeviceBase {
	connect() {
		const controller = this;

		this.connectBase({
			channel: 'DeviceIfChannel'
		});

		const el = this.element as HTMLDivElement;
		const leddriver = JSON.parse(el.dataset.leddriver!);
		console.log(leddriver);

		var command = '0'.repeat(leddriver.led_num);

		$(".led-color").each(function () {
			$(this).css("background-color", $(this).data("rgb"));
		});

		$('.led-color').on('click', function () {
			$(this).parent().find('.led-active').css('background', $(this).css('background'));
			console.log($(this).data());
			if ($(this).data().ledid != 0) {
				command = setCharAt(command, $(this).data().ledid - 1, '' + $(this).data().cmd);
			} else {
				command = ('' + $(this).data().cmd).repeat(leddriver.led_num);
				$('.led-active').css('background', $(this).css('background'));
			}
			console.log(command);
			controller.sendCmd(command);
		});

		function setCharAt(str: string, index: number, chr: string) {
			if (index > str.length - 1)
				return str;
			return str.slice(0, index) + chr + str.slice(index + 1);
		}
	}
}